import { OrganizationRole } from '@customTypes/clinician';

export const USER_ROLE_MAPPING: Record<OrganizationRole, string> = {
  [OrganizationRole.ADMIN]: 'Admin',
  [OrganizationRole.CLINICIAN]: 'Ordering Provider',
  [OrganizationRole.DELEGATE]: 'Organization Delegate',
};
